export default class UrlDefineBase {
  public static readonly USER_PREFIX = '/user'
  public static readonly LOGIN = UrlDefineBase.USER_PREFIX + '/login'
}
